import React from 'react';
import { View } from 'react-native';

import { useThemedStyles } from '../../../hooks/useThemedStyles';
import MachineSetupList from './MachineSetupList';
import { GET_MACHINE_SETUPS } from '../../../../common/graphql/machineSetup';

const MachineSetupListView = () => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.container}>
			<MachineSetupList
				query={GET_MACHINE_SETUPS}
				initialSortBy="dueDate"
				initialSortDirection={-1}
				initialPerPage={15}
				listId="native_machine_setups"
			/>
		</View>
	);
};

const createStyles = ({ ui: { colors } }) => ({
	container: {
		flex: 1,
		backgroundColor: colors.canvas,
	},
});

export default MachineSetupListView;
